import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Card,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import platforms from "../../constants/platforms.json"

function SearchProduct({ handleSubmit, scrapedProductData, loader }) {
  const [validated, setValidated] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState(platforms[0].name);
  let specs = "";
  const keyword = "";
  const title = scrapedProductData?.title.length > 0 ? scrapedProductData.title.toString().trim() : "";
  const description = scrapedProductData?.description.length > 0 ? scrapedProductData?.description.toString().trim() : "";

  if (scrapedProductData?.features.length > 0) {
    specs = [];
    scrapedProductData?.features.forEach((feature) =>
      specs.push(`${feature.name}:${feature.value}`)
    );
    specs = specs.toString().trim() || "";
  }

  const asin = scrapedProductData?.asin || "";
  const link = scrapedProductData?.link || "";

  const [formData, setFormData] = useState({
    keyword,
    title,
    description,
    specs,
    audience: "",
    asin,
    link,
    platform: platforms[0].name
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handlePlatformSelection = (eventKey) => {
    setSelectedPlatform(eventKey);
    handleInputChange({ target: { name: "platform", value: eventKey } });
  };

  function handleFormSubmit(event) {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    if(formData.keyword === "" ||
       formData.title === "" ||
        formData.description === "" || 
        formData.specs === "" || 
        formData.audience === "" ||
        formData.asin === "" ||
        formData.link === "" ||
        formData.platform === "") {
        return false;
      }

    if (form.checkValidity() === true) {
      formData.asin = selectedPlatform === "amazon" ? formData.asin : "";
      formData.link = selectedPlatform === "amazon" ? formData.link : "";
      handleSubmit(event, formData)
    }
  }

  return (
    <Card className="search-product-card">
      <Card.Header className="form-header">Optimize Data</Card.Header>
      <Card.Body>
        <Container>
          <Row>
            <Col className="product-area-content">
              <Form
                onSubmit={handleFormSubmit}
                noValidate
                validated={validated}
              >
                <Container>
                  <Row>
                    <Col xl="12">
                      <Form.Group controlId="formKeyword" className="mb-3">
                        <Form.Control
                          type="text"
                          name="keyword"
                          placeholder="Keyword"
                          value={formData.keyword}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>

                    {selectedPlatform === "amazon" && (<>
                      <Col xl="12">
                        <Form.Group controlId="formASIN" className="mb-3">
                          <Form.Control
                            type="text"
                            name="asin"
                            placeholder="ASIN"
                            value={formData.asin}
                            onChange={handleInputChange}
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col xl="12">
                          <Form.Group controlId="formLink" className="mb-3">
                            <Form.Control
                              type="text"
                              name="link"
                              placeholder="Link"
                              value={formData.link}
                              onChange={handleInputChange}
                              required
                            />
                          </Form.Group>
                        </Col>
                      </>
                    )}
                    <Col xl="12">
                      <Form.Group controlId="formTitle" className="mb-3">
                        <Form.Control
                          type="text"
                          name="title"
                          placeholder="Title"
                          value={formData.title}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12">
                      <Form.Group controlId="formDescription" className="mb-3">
                        <Form.Control
                          as="textarea"
                          name="description"
                          placeholder="Description"
                          value={formData.description}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12">
                      <Form.Group controlId="formSpecs" className="mb-3">
                        <Form.Control
                          as="textarea"
                          name="specs"
                          placeholder="Specs"
                          value={formData.specs}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12">
                      <Form.Group controlId="formAudience" className="mb-3">
                        <Form.Control
                          as="textarea"
                          name="audience"
                          placeholder="Audience"
                          value={formData.audience}
                          onChange={handleInputChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col xl="12" className="mb-3">
                      <Dropdown onSelect={handlePlatformSelection}>
                        <Dropdown.Toggle
                          variant="secondary"
                          id="dropdown-basic"
                        >
                          <label className="m-0 text-capitalize">
                            {selectedPlatform
                              ? selectedPlatform
                              : "Select an platform"}
                          </label>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {platforms.length > 0 &&
                            platforms.map((platform) => (
                              <Dropdown.Item
                                key={platform.id}
                                eventKey={platform.name}
                                className="text-capitalize"
                              >
                                {platform.name}
                              </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl="12">
                      {loader ? (
                        <Button variant="primary" disabled>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          &nbsp;&nbsp;Optimizing...
                        </Button>
                      ) : (
                        <Button variant="primary" type="submit">
                          Optimize
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
}

export default SearchProduct;
